import React from 'react';
import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from './pages/login/login';
import Dashs from './pages/dashs/dashs';
import Cadcliente from './pages/cadastros/cliente';
import Cadcampanha from './pages/cadastros/campanha';
import Caduser from './pages/cadastros/usuarios';
import Acesso from './pages/cadastros/acesso';
import Diario from './pages/diario/diario';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MenuProvider } from "./context/MenuContext"; // Importando o contexto

function App() {
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "authToken" && !localStorage.getItem("authToken")) {
        window.location.reload();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <MenuProvider>
      <Router>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashs" element={<Dashs />} />
          <Route path="/cliente" element={<Cadcliente />} />
          <Route path="/campanha" element={<Cadcampanha />} />
          <Route path="/usuarios" element={<Caduser />} />
          <Route path="/acesso" element={<Acesso />} />
          <Route path="/diario" element={<Diario />} />
        </Routes>
      </Router>
    </MenuProvider>
  );
}

export default App;
